export default __webpack_public_path__ + "deep_planet_.825b8bc.png";